/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.getPublicQrCodeScanToken.internal

import features.getPublicQrCodeScanToken.models.GetPublicQrCodeScanTokenResponseModel
import features.getPublicQrCodeScanToken.models.PublicQrCodeScanTokenRequest
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class GetPublicQrCodeScanTokenRequest : NetworkRequest() {

    suspend fun getPublicQrCodeScanToken(
        overrideHeaders: Map<String, String>? = null,
        publicQrCodeScanTokenRequest: PublicQrCodeScanTokenRequest
    ): IOResult<GetPublicQrCodeScanTokenResponseModel> {
        return safeNetworkCall {
            post<GetPublicQrCodeScanTokenResponseModel, PublicQrCodeScanTokenRequest>(
                endpoint = GetPublicQrCodeScanTokenEndpoint,
                requestBody = publicQrCodeScanTokenRequest,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
